var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsTailwind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 50.0205C91.6656 50.0205 70.8328 66.683 62.4984 100.005C75 83.3423 89.5836 77.0962 106.249 81.2603C115.759 83.6362 122.555 90.5356 130.08 98.1697C142.335 110.606 156.518 124.998 187.502 124.998C220.833 124.998 241.669 108.336 250 75.0111C237.502 91.6736 222.918 97.9228 206.249 93.7587C196.743 91.3828 189.946 84.4834 182.422 76.8493C170.167 64.4134 155.98 50.0205 125 50.0205V50.0205ZM62.4984 124.998C29.1672 124.998 8.33125 141.661 0 174.986C12.4984 158.323 27.082 152.074 43.7508 156.241C53.2575 158.62 60.0538 165.517 67.5785 173.148C79.8331 185.584 94.0196 199.98 125 199.98C158.334 199.98 179.167 183.317 187.502 149.992C175 166.655 160.416 172.904 143.751 168.737C134.241 166.364 127.445 159.461 119.92 151.83C107.665 139.394 93.4819 124.998 62.4984 124.998V124.998Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsTailwind);
export default __webpack_public_path__ + "static/media/skills-tailwind.aa786968e15a1f4874bf75510df267d7.svg";
export { ForwardRef as ReactComponent };